import Head from 'next/head'

export const PageTitle = (props: { title: string }) => {
  return (
    <Head>
      <title>{`Rentana - ${props.title}`}</title>
    </Head>
  )
}
